import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { HighSchoolDetailPage } from './pages/HighSchoolDetailPage';
import { DistrictDetailPage } from './pages/DistrictDetailPage';
import { StaffAccountsPage } from './pages/StaffAccountsPage';
import { DirectoryPage } from './pages/DirectoryPage';

export function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<DirectoryPage />} />
        <Route path="/highschools" element={<DirectoryPage />} />
        <Route path="/highschools/:nid" element={<HighSchoolDetailPage />} />
        <Route path="/districts" element={<DirectoryPage />} />
        <Route path="/districts/:ndid" element={<DistrictDetailPage />} />
        <Route path="/staff" element={<StaffAccountsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
